import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'
import BekreftetGrunnbokBestilling from './BekreftetGrunnbokBestilling.jsx'
import TinglystDokumentBestilling from './TinglystDokumentBestilling.jsx'

class UtskriftbestillingList extends Component {
    state = {
        bestillinger: [],
        isLoading: false,
        continuationToken: null
    }

    UNSAFE_componentWillMount = () => {
        this.getBestillinger()
    }

    getBestillinger = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/utskriftbestillinger/`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                bestillinger: [...this.state.bestillinger, ...data.bestillinger],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    render() {
        const { t } = this.props
        var antallBestillinger = this.state.continuationToken ? `${this.state.bestillinger.length}/${this.props.settings.antallUtskriftBestillinger}` : this.props.settings.antallUtskriftBestillinger
        return (
            <li>
                <div className="section-header navigation" onClick={this.props.onNavigateBack}>
                    <span className="icon"><i className={"fa fa-fw fa-arrow-left"}></i></span>
                    <span className="title">{t('tilbake')}</span>
                </div>

                <div className="section-header subsection">
                    { !this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-image"></i></span>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }                    
                    <span className="title">{t('bestilteutskrifter')} {!this.state.isLoading && `(${antallBestillinger})`}</span>
                </div>
                <div>
                    <ul>
                        { this.state.bestillinger.map((b, index) => {
                            if (b.dokumentnummer > 0) {
                                return (<TinglystDokumentBestilling key={b.referansenummer} bestilling={b} isLast={index==this.state.bestillinger.length-1} onEvent={this.props.onEvent} />)
                            }
                            else {
                                return (<BekreftetGrunnbokBestilling key={b.referansenummer} bestilling={b} isLast={index==this.state.bestillinger.length-1} onEvent={this.props.onEvent} />)
                            }}
                        )}
                        { this.state.continuationToken &&
                            <li key="HentFlere">
                                <div className="section-header subsection button" onClick={this.getBestillinger}>
                                    <span>{t('hent.bestilling')}</span>
                                </div>
                            </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(UtskriftbestillingList)